import React from 'react';
import mergePartialTheme from "./mergePartialTheme";
import { ChakraProvider } from '@chakra-ui/react';
import { spTheme } from "./";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Custom theme provider used to merge consumer themes with the base SP theme
 *
 * @param partialTheme Subset of theme to override or provide custom
 *     consumer-specific values
 */
var CustomThemeProvider = _ref => {
  var {
    baseTheme = spTheme,
    children,
    resetCSS = true,
    partialTheme
  } = _ref;
  var mergedTheme = mergePartialTheme(partialTheme, baseTheme);
  return ___EmotionJSX(ChakraProvider, {
    resetCSS: resetCSS,
    theme: mergedTheme
  }, children);
};
export default CustomThemeProvider;